<h2 class="title sir-text-style-paragraph-l-bold" data-cy="textarea-header-section">
    {{ translations()!.applicationSpecificPage.textareaTitle }}
</h2>
<div class="options-container">
    <div class="option-text-field">
        <textarea
            #textAreaElement
            [ngModel]="answer()"
            (ngModelChange)="onTextChange($event)"
            data-cy="text-area"
            class="text-area sir-text-style-paragraph-m-default"
            [placeholder]="translations()!.applicationSpecificPage.textareaQuestionPlaceholder"
            rows="40">
        </textarea>

        <p data-cy="paragraph" class="description sir-text-style-paragraph-m-default">
            {{ translations()!.applicationSpecificPage.textareaDescription }}
        </p>
    </div>
</div>
